export const saved = {
  action: 'Save now',
  saving: 'Saving',
  saved: 'Saved',
  now: 'Just now',
  recently: 'Saved seconds ago',
  second: 'sec',
  seconds: 'sec',
  minute: 'min',
  minutes: 'min',
  hour: 'hour',
  hours: 'hours',
  day: 'day',
  days: 'days',
  ago: 'ago',
  error: {
    title: 'Error',
    subtitle: 'Try again',
    message: 'There was a problem saving your data, please try again.',
  },
};
